export const queryKeys = {
  getMealData: 'get-meal-data',
  getAllScheduleData: 'get-all-schedule-data',
  getFutureMealSchedules: 'get-future-meal-schedules',
  getAllMealPortionsData: 'get-all-meal-portions-data',
  getAllPortionSizePrice: 'get-all-portion-size-price',
  getAllCanteens: 'get-all-canteens',
  getAllTagsData: 'get-all-tags-data',
  getAllIngredientsData: 'get-all-ingredients-data',
};
